import { render } from "./Definitions.vue?vue&type=template&id=fd624080&scoped=true"
import script from "./Definitions.vue?vue&type=script&lang=js"
export * from "./Definitions.vue?vue&type=script&lang=js"

import "./Definitions.vue?vue&type=style&index=0&id=fd624080&scoped=true&lang=css"

import exportComponent from "/home/nodeapps/vitamins/aaa/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd624080"]])

export default __exports__